import { render, staticRenderFns } from "./BasicTopNotification.vue?vue&type=template&id=2860d111&scoped=true&"
import script from "./BasicTopNotification.vue?vue&type=script&lang=js&"
export * from "./BasicTopNotification.vue?vue&type=script&lang=js&"
import style0 from "./BasicTopNotification.vue?vue&type=style&index=0&id=2860d111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860d111",
  null
  
)

export default component.exports